import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = { class: "truncate" }
const _hoisted_4 = { class: "break-words" }
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "italic"
}
const _hoisted_8 = { class: "flex justify-end" }
const _hoisted_9 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_10 = ["href"]

import { ArrowDownTrayIcon } from '@heroicons/vue/20/solid'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

import DescriptionHeader from '@/components/neue/DescriptionHeader.vue'
import EmptyState from '@/components/neue/EmptyState.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import NeueTablist from '@/components/neue/NeueTablist.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import NeueWell from '@/components/neue/NeueWell.vue'
import TablistHeader from '@/components/neue/TablistHeader.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import NewReportModal from '@/components/neue/NewReportModal.vue'
import BasicSpinner from '@/components/BasicSpinner.vue'
import api from '@/store/api'
import { mapType } from '@/store/mappers'
import privilegeService from '@/services/privilege.service'


export default {
  __name: 'ReportDownloadHistory',
  props: {
  reportTypeFilter: { type: String, default: null },
  buttonLabel: { type: String, default: '+ Report' },
  headerName: { type: String, default: 'Report download history' },
  simplifiedForPayouts: { type: Boolean, default: false },
  dateRange: { type: Object, default: null },
  simplifiedReportType: { type: String, default: null },
  dateBasisNote: { type: String, default: null }
},
  setup(__props) {

const props = __props

const store = useStore()
const modalOpen = ref(false)

const canCreateReports = computed(() => privilegeService.canAccessResourceAction('reports', null, 'create'))
const canReadReports = computed(() => privilegeService.canAccessResourceAction('reports', null, 'read'))
const downloadButtonActive = computed(
  () =>
    (!props.simplifiedForPayouts && !props.simplifiedReportType) ||
    (props.dateRange?.beginning_date && props.dateRange?.ending_date)
)

const reports = computed(() => {
  let list = mapType('data_download') ?? []
  if (props.reportTypeFilter) {
    list = list.filter(r => r.attributes?.report_type === props.reportTypeFilter)
  }
  return list.sort((a, b) => new Date(b.attributes.created_at) - new Date(a.attributes.created_at))
})

const cols = [
  { width: 'minmax(120px, 1fr)' },
  { width: 'minmax(150px, 2fr)' },
  { width: 'minmax(120px, 1.5fr)' },
  { width: '160px' }
]

const timeFormat = x => new Intl.DateTimeFormat([], { dateStyle: 'short', timeStyle: 'short' }).format(new Date(x))

function openModal() {
  if ((props.simplifiedForPayouts || props.simplifiedReportType) && !props.dateRange) return
  modalOpen.value = true
}

onMounted(() => {
  if (props.reportTypeFilter && canReadReports.value) {
    const existing = mapType('data_download')
    if (!existing?.length) {
      api.call('GET', 'data_downloads')
    }
  }
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (canCreateReports.value)
      ? (_openBlock(), _createBlock(NewReportModal, {
          key: 0,
          "is-open": modalOpen.value,
          "simplified-for-payouts": __props.simplifiedForPayouts,
          "payout-date-range": __props.dateRange,
          "simplified-report-type": __props.simplifiedReportType,
          "date-basis-note": __props.dateBasisNote,
          onCloseModal: _cache[0] || (_cache[0] = $event => (modalOpen.value = false))
        }, null, 8, ["is-open", "simplified-for-payouts", "payout-date-range", "simplified-report-type", "date-basis-note"]))
      : _createCommentVNode("", true),
    (canReadReports.value)
      ? (_openBlock(), _createBlock(DescriptionHeader, {
          key: 1,
          name: __props.headerName
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    (reports.value?.length && canReadReports.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(NeueTablist, null, {
            head: _withCtx(() => [
              _createVNode(TablistHeader, null, {
                default: _withCtx(() => [
                  _createVNode(TablistGrid, {
                    columns: cols,
                    header: "",
                    class: "items-center"
                  }, {
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createElementVNode("div", null, "Time Created", -1)),
                      _cache[2] || (_cache[2] = _createElementVNode("div", null, "Report Description", -1)),
                      _cache[3] || (_cache[3] = _createElementVNode("div", null, "Emailed To", -1)),
                      _createElementVNode("div", _hoisted_2, [
                        (canCreateReports.value)
                          ? (_openBlock(), _createBlock(NeueButton, {
                              key: 0,
                              type: downloadButtonActive.value ? 'primary' : 'inactive',
                              onClick: openModal
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.buttonLabel), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value, (report) => {
                return (_openBlock(), _createBlock(TablistRow, {
                  key: report.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(TablistGrid, {
                      columns: cols,
                      class: "items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(timeFormat(report.attributes.created_at)), 1),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(report.attributes.display_name), 1),
                        _createElementVNode("div", _hoisted_5, [
                          (report.attributes.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(report.attributes.email), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, "No email"))
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          (report.attributes.is_expired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Expired"))
                            : (report.attributes.link_to_report)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  href: report.attributes.link_to_report,
                                  class: "flex items-center",
                                  target: "_blank"
                                }, [
                                  _cache[4] || (_cache[4] = _createTextVNode(" Download ", -1)),
                                  _createVNode(_unref(ArrowDownTrayIcon), { class: "ml-2 h-5 w-5 inline" })
                                ], 8, _hoisted_10))
                              : (_openBlock(), _createBlock(BasicSpinner, { key: 2 }))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!reports.value?.length && canReadReports.value)
      ? (_openBlock(), _createBlock(NeueWell, { key: 3 }, {
          default: _withCtx(() => [
            _createVNode(EmptyState, { plural: "downloaded reports yet" }, {
              default: _withCtx(() => [
                (canCreateReports.value)
                  ? (_openBlock(), _createBlock(NeueButton, {
                      key: 0,
                      type: downloadButtonActive.value ? 'primary' : 'inactive',
                      onClick: openModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.buttonLabel), 1)
                      ]),
                      _: 1
                    }, 8, ["type"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

}